import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import ProjectCard from 'src/components/ProjectCard';
import { getVendorData } from '../../actions';
import Skeleton from '@material-ui/lab/Skeleton';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import imageIntro from '../../assets/images/photo-1519337265831-281ec6cc8514.jpg';

const useStyles = makeStyles((theme) => ({
    root: {},
    grid: {
        marginTop: theme.spacing(2)
    },
    mb20: {
        marginBottom: theme.spacing(2)
    },
    mb50: {
        marginBottom: theme.spacing(5)
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2)
    },
    title: {
        position: 'relative',
        '&:before': {
            position: 'absolute',
            bottom: -8,
            left: 0,
            content: '" "',
            height: 3,
            width: 48,
            backgroundColor: theme.palette.primary.main
        }
    },
    arrowIcon: {
        marginLeft: theme.spacing(1)
    }
}));

function Projects({ className, ...rest }) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const session = useSelector((state) => state.session);
    const vendor = useSelector((state) => state.vendor);    
    useEffect(() => {
        if (session && session.loggedIn) {
            dispatch(getVendorData(null,session.user.correo));
           // dispatch(getComapanyNames(session.user.correo));
        }
    }, []);
    
    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >

            <div className={classes.mb20}>
                <div className={[classes.header]}>
                    <Typography
                        className={classes.title}
                        variant="h3"
                    >
                        Información de la cuenta {vendor.loading ?
                        <CircularProgress size={20} style={{ 'marginLeft': '10px' }}/>
                        :
                        ''
                    }
                    </Typography>
                </div>
                {vendor.vendor ? <ProjectCard vendor={vendor}/> :
                    <Skeleton variant="rect" width={'100%'} height={101}/>}
            </div>

            <div className={classes.header}>
                {/*<Typography
                    className={classes.title}
                    variant="h3"
                >
                    Manténgase actualizado!
                </Typography>*/}

                <img src={imageIntro} alt="" width={'100%'}/>
            </div>

            {/*<Typography
                color="textSecondary"
                variant="subtitle2"
                className={classes.mb50}
            >
                Este sitio está pensado para poder ofrecerle información relacionada a usted como proveedor, para que en
                cualquier momento pueda consultar la información acerca de sus pedidos, facturas, notas de cargo, estado
                de cuenta, etc.
                <br/>
                Esperamos sea de utilidad y cualquier duda o aclaración póngase en contacto con nosotros. <br/>
                Para cualquier duda favor de ponerse en contacto con nosotros. <strong>Tiendas Chapur S.A. de
                C.V.</strong>
            </Typography>*/}

            {/*{hasPermiso(BALANCES_GENERALES) && <Grid
                container
                spacing={3}
                className={classes.grid}
            >
                <Grid
                    item
                    lg={4}
                    sm={6}
                    xs={12}
                >
                    {vendor.vendor ?
                        <TodaysMoney
                            text={'Balance'}
                            value={vendor.vendor.data.balance}
                            currency={vendor.vendor.data.creditlimitcurrency}
                            color={'balance'}
                        />
                        : <Skeleton variant="rect" width={'100%'} height={118}/>}
                </Grid>
                <Grid
                    item
                    lg={4}
                    sm={6}
                    xs={12}
                >
                    {vendor.vendor ?
                        <TodaysMoney
                            text={'Pedido no facturados'}
                            value={vendor.vendor.data.unbilledorders}
                            currency={vendor.vendor.data.unbilledordersprimarycurrency}
                            color={'balance2'}
                        />
                        : <Skeleton variant="rect" width={'100%'} height={118}/>}
                </Grid>
                <Grid
                    item
                    lg={4}
                    sm={6}
                    xs={12}
                >
                    {vendor.vendor ?
                        <TodaysMoney
                            text={'En tránsito'}
                            value={vendor.vendor.data.intransitbalance}
                            currency={vendor.vendor.data.intransitbalancecurrency}
                            color={'balance3'}
                        />
                        : <Skeleton variant="rect" width={'100%'} height={118}/>}
                </Grid>
            </Grid>}*/}
        </div>
    );
}

Projects.propTypes = {
    className: PropTypes.string
};

export default Projects;
